import { render, staticRenderFns } from "./videoiframe.vue?vue&type=template&id=083b0a8c&"
import script from "./videoiframe.vue?vue&type=script&lang=js&"
export * from "./videoiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083b0a8c')) {
      api.createRecord('083b0a8c', component.options)
    } else {
      api.reload('083b0a8c', component.options)
    }
    module.hot.accept("./videoiframe.vue?vue&type=template&id=083b0a8c&", function () {
      api.rerender('083b0a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6wGS5YGi759/JS/videoiframe.vue"
export default component.exports